import { IconContent } from '@icons';

export const ordersFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M4 3h16v18H4V3Zm5 4V6H7v1h2Zm8-1v1h-7V6h7Zm-4.5 4V9h-1v1H9.92l-.5.5v3l.5.5h3.66v2H9.5v1h2v1h1v-1h1.58l.5-.5v-3l-.5-.5h-3.66v-2h4.08v-1h-2Z"/>',
};
